import { ApiStoreStatsResponse } from "@incendium/api";
import { getStoreStats } from "features/onboarding/woocommerce/services/storeStatsService";
import { usePolling } from "Hooks";
import { useCallback } from "react";

const STORE_STATS_POLL_INTERVAL_MS = 1000;

export function useWooStoreStats(projectId: number | undefined) {
  const pollFn = useCallback(async () => {
    if (!projectId) {
      return null;
    }
    return getStoreStats(projectId);
  }, [projectId]);

  const { data, loading, error, refetch } = usePolling<ApiStoreStatsResponse | null>({
    pollFn,
    interval: STORE_STATS_POLL_INTERVAL_MS,
    enabled: !!projectId,
    immediate: true,
  });

  return {
    stats: data,
    loading: loading && data == null,
    error: !!error,
    refetch,
  };
}
